export default "__VITE_ASSET__DoBdYv1n__"